// @flow

import React, { Component } from 'react';
import Relay from 'react-relay';
import { Row, Col } from 'react-bootstrap/lib';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';

import { uiStateStoreInstance } from '../../Stores/UIStateStore';
import { filterNotNullEdgeNodes, convertEvent } from '../../libs/Extract';
import calculateEventStyle from '../../libs/Event';

let eventsArray: Array<MeetingEvent> = [];

function mergeEventsAndCreateSharedArr(contactEvents, meetingroomEvents, otherresourcesEvents) {
  let contactsEventsFilteredTaged = [];
  let meetingRoomsEventsFilteredTaged = [];
  let otherResourcesEventsFilteredTaged = [];

  const contactsEventsFiltered = contactEvents.edges.length > 0 ? filterNotNullEdgeNodes(contactEvents.edges[0].node.events) : [];
  if (contactsEventsFiltered) {
    contactsEventsFiltered.forEach(event => {
      const owner = { email: contactEvents.edges[0].node.email, displayName: contactEvents.edges[0].node.displayName };
      const eventWithOwner = Object.assign(event, { owner });
      contactsEventsFilteredTaged.push(eventWithOwner);
    });
  } else {
    contactsEventsFilteredTaged = [];
  }

  const meetingRoomsEventsFiltered = meetingroomEvents.edges.length > 0 ? filterNotNullEdgeNodes(meetingroomEvents.edges[0].node.events) : [];
  if (meetingRoomsEventsFiltered) {
    meetingRoomsEventsFiltered.forEach(event => {
      const owner = { email: meetingroomEvents.edges[0].node.email, displayName: meetingroomEvents.edges[0].node.displayName };
      const eventWithOwner = Object.assign(event, { owner });
      meetingRoomsEventsFilteredTaged.push(eventWithOwner);
    });
  } else {
    meetingRoomsEventsFilteredTaged = [];
  }

  const otherResourcesEventsFiltered = otherresourcesEvents.edges.length > 0 ? filterNotNullEdgeNodes(otherresourcesEvents.edges[0].node.events) : [];
  if (otherResourcesEventsFiltered) {
    otherResourcesEventsFiltered.forEach(event => {
      const owner = { email: otherresourcesEvents.edges[0].node.email, displayName: otherresourcesEvents.edges[0].node.displayName };
      const eventWithOwner = Object.assign(event, { owner });
      otherResourcesEventsFilteredTaged.push(eventWithOwner);
    });
  } else {
    otherResourcesEventsFilteredTaged = [];
  }

  const mergedEvents = [...contactsEventsFilteredTaged, ...meetingRoomsEventsFilteredTaged, ...otherResourcesEventsFilteredTaged];
  eventsArray = mergedEvents;
  mergedEvents.forEach(event => {
    uiStateStoreInstance.events.push(event);
  });
}

class Event extends Component {
  constructor(props) {
    super(props);
    const { contacts, meetingRooms, otherResources } = props.event;
    mergeEventsAndCreateSharedArr(contacts, meetingRooms, otherResources);
  }

  state: {
    eventSelected: Object,
    modalShowEvent: boolean,
  } = {
    eventSelected: {},
    modalShowEvent: false,
  }

  componentWillReceiveProps(nextProps: Object) {
    const { contacts, meetingRooms, otherResources } = nextProps.event;
    mergeEventsAndCreateSharedArr(contacts, meetingRooms, otherResources);
  }
  props: {
    event: Object,
    endDate: Object,
    startDate: Object,
    events: Array<MeetingEvent>,
    schedulerHours: number,
    displayName: string,
    datePickerStart: Object,
    datePickerEnd: Object,
    showEventModal: Function,
    mode: string,
    languagedata: Object,
    emails: Array<string>,
    showEventModal: Function,
  }

  _renderScheduler= (props: Object, events: Array<Object>, languagedata: Object) => {
    const { startDate, endDate, schedulerHours, datePickerStart, datePickerEnd } = props;
    return (
      <div>
        <Row className="multislots-user">
          <Col xs={3} className="multislots-padding">{this.props.displayName}</Col>
          <Col xs={9} className="multislots-padding events">
            {events.map((event, index) => {
              const location = event.location.displayName ? `${event.location.displayName} <br /> ` : '';
              const eventTime = event.isAllDay ? languagedata.all_day_event : `${location} ${moment.unix(event.startDate).format('LT')} - ${moment.unix(event.endDate).format('LT')}`;
              return (
                <div
                  onClick={() => this.props.showEventModal(event)}
                  key={index}
                  className="scheduler-event"
                  style={calculateEventStyle(convertEvent(event), schedulerHours, startDate, endDate, datePickerStart, datePickerEnd)}
                  data-tip={`<b>${event.subject}</b> <br /> ${eventTime}`}
                >
                  {' '}
                </div>);
            })}
          </Col>
        </Row>
      </div>);
  }

  render() {
    const { languagedata } = this.props;
    return (
      <div>
        {this.props.mode === 'calendar' ? '' : this._renderScheduler(this.props, eventsArray, languagedata)}
        <ReactTooltip html={true} />
      </div>
    );
  }
}

export default Relay.createContainer(Event, {
  initialVariables: {
    startDate: null,
    endDate: null,
    emails: ['null'],
  },
  fragments: {
    event: () => Relay.QL`
        fragment on Viewer {
          contacts(first: 1, emails: $emails) {
            edges {
              node {
                email
                displayName
              }
            }
            edges {
              node {
                events (first: 10000, startDate: $startDate, endDate: $endDate) {
                  edges {
                    node {
                      iCalUId
                      id
                      subject
                      body
                      startDate
                      endDate
                      isCancelled
                      location {
                        displayName
                      }
                      isAllDay
                      occupancy
                      organizer {
                        displayName
                        email
                      }
                      requiredAttendees {
                        displayName
                        email
                      }
                      optionalAttendees {
                        displayName
                        email
                      }
                    }
                  }
                }
              }
            }
          }
          meetingRooms(first: 1, emails: $emails) {
            edges {
              node {
                email
                displayName
              }
            }
            edges {
              node {
                events (first: 10000, startDate: $startDate, endDate: $endDate) {
                  edges {
                    node {
                      iCalUId
                      id
                      subject
                      body
                      startDate
                      endDate
                      isCancelled
                      location {
                        displayName
                      }
                      isAllDay
                      occupancy
                      organizer {
                        displayName
                        email
                      }
                      requiredAttendees {
                        displayName
                        email
                      }
                      optionalAttendees {
                        displayName
                        email
                      }
                    }
                  }
                }
              }
            }
          }
          otherResources(first: 1, emails: $emails) {
            edges {
              node {
                email
                displayName
              }
            }
            edges {
              node {
                events (first: 10000, startDate: $startDate, endDate: $endDate) {
                  edges {
                    node {
                      iCalUId
                      id
                      subject
                      body
                      startDate
                      endDate
                      isCancelled
                      location {
                        displayName
                      }
                      isAllDay
                      occupancy
                      organizer {
                        displayName
                        email
                      }
                      requiredAttendees {
                        displayName
                        email
                      }
                      optionalAttendees {
                        displayName
                        email
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Components/Scheduler/Event.js